/**
 * 阅读器数据服务（Axios 版本）
 * 替换原有的 WebSocket 实现
 */
import { ref, watch } from 'vue';
import { getChapterIntroduce, getChapterContent } from './api';

export const readerChapterWebSocket = (currentId, currentNovelId) => {
    const connected = ref(true); // Axios 总是"连接"状态
    const chapterId = ref(currentId);
    const novelId = ref(currentNovelId);
    const chapter_introduce = ref([null]);
    const chapter_content = ref({});
    const loading = ref(false);
    const error = ref(null);

    // 请求章节列表和当前章节内容
    const fetchNovelsChapter = async () => {
        loading.value = true;
        error.value = null;

        try {
            // 并行请求章节列表和章节内容
            const [chaptersResult, contentResult] = await Promise.all([
                getChapterIntroduce(novelId.value),
                getChapterContent(novelId.value, chapterId.value)
            ]);

            // Result 结构：{ code: 0, msg: "success", data: [...] }
            if (chaptersResult.code === 0) {
                chapter_introduce.value = chaptersResult.data;
                console.log('获取章节列表成功');
            } else {
                error.value = chaptersResult.msg || '获取章节列表失败';
            }

            if (contentResult.code === 0) {
                chapter_content.value = contentResult.data;
                console.log('获取章节内容成功');
            } else {
                error.value = contentResult.msg || '获取章节内容失败';
            }
        } catch (err) {
            console.error('请求数据失败:', err);
            error.value = err.message || '请求数据失败';
        } finally {
            loading.value = false;
        }
    };

    // 仅请求章节内容（切换章节时使用）
    const fetchChapterContent = async () => {
        loading.value = true;
        error.value = null;

        try {
            const contentResult = await getChapterContent(novelId.value, chapterId.value);
            if (contentResult.code === 0) {
                chapter_content.value = contentResult.data;
                console.log('获取章节内容成功');
            } else {
                error.value = contentResult.msg || '获取章节内容失败';
            }
        } catch (err) {
            console.error('请求章节内容失败:', err);
            error.value = err.message || '请求章节内容失败';
        } finally {
            loading.value = false;
        }
    };

    // 监听 chapterId 变化，重新请求章节内容
    watch(() => chapterId.value, (newId) => {
        if (newId) {
            fetchChapterContent();
        }
    }, { immediate: false });

    // 更新章节参数
    const updateChapterParams = (newChapterId) => {
        chapterId.value = newChapterId;
    };

    return {
        connected,
        chapter_introduce,
        chapter_content,
        loading,
        error,
        fetchNovelsChapter,
        updateChapterParams
    };
};
